import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

import { environment } from '../../../environments/environment'
import { ApiResponse } from '../../shared/types/response.type'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class MaintenanceService {
	constructor(
		private readonly httpClient: HttpClient,
		private readonly router: Router,
	) {}

	fetchMaintenanceStatus(domain: string) {
		return this.httpClient.get<ApiResponse<{ ISONMAINTENANCE: boolean }[]>>(`${API_URL}/api/service_config/maintenance/${domain}`)
	}

	redirectToMaintenance() {
		this.router.navigate(['/maintenance'])
	}
}
